(function () {
  'use strict';
  const roots = Array.from(document.querySelectorAll('[data-ic-bridge]')).filter(root => !root.dataset.icBridgeStarted);
  if (!roots.length) return;
  const strings = JSON.parse(roots[0].querySelector('[data-ic-bridge-text]').textContent);
  const text = key => strings[key] || strings.error;
  const endpoint = '/apps/my-grey';
  let active = false;
  let statusGeneration = 0;
  const generations = new WeakMap();
  const node = (tag, value, className) => {
    const el = document.createElement(tag);
    if (value != null) el.textContent = String(value);
    if (className) el.className = className;
    return el;
  };
  async function request(resource, body) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(endpoint + '?resource=' + encodeURIComponent(resource), {
        method: body === undefined ? 'GET' : 'POST', credentials: 'same-origin', cache: 'no-store',
        signal: controller.signal,
        ...(body === undefined ? {} : { headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      });
      let result;
      try { result = await response.json(); } catch (_) { throw new Error(text('unavailable')); }
      if (!response.ok) throw new Error(result.error || text('error'));
      return result;
    } catch (error) {
      if (error.name === 'AbortError' || error instanceof TypeError) throw new Error(text('unavailable'));
      throw error;
    } finally { clearTimeout(timeout); }
  }
  function message(form, value, error) {
    const output = form.querySelector('[data-ic-form-message]');
    output.textContent = value;
    output.dataset.error = String(!!error);
  }
  function gate(mode) {
    active = mode === 'active';
    roots.forEach(root => {
      root.querySelector('[data-ic-gate]').hidden = active;
      root.querySelector('[data-ic-gate-message]').textContent = active ? '' : text(mode);
      root.querySelector('[data-ic-login]').hidden = mode !== 'guest';
      root.querySelector('[data-ic-join]').hidden = mode !== 'join';
      root.querySelector('[data-ic-retry]').hidden = mode !== 'unavailable';
      root.querySelector('[data-ic-fields]').disabled = !active;
      root.querySelector('form').hidden = !active;
      root.querySelector('[data-ic-private]').hidden = !active;
      if (!active) {
        generations.set(root, (generations.get(root) || 0) + 1);
        root.querySelectorAll('[data-ic-my-shares],[data-ic-my-trades]').forEach(el => el.replaceChildren());
        const balance = root.querySelector('[data-ic-balance]');
        if (balance) balance.textContent = '—';
      }
    });
  }
  async function loadMember() {
    if (roots[0].dataset.icAccount === 'guest') { gate('guest'); return; }
    const generation = ++statusGeneration;
    gate('loading');
    try {
      const result = await request('instax-club');
      if (generation !== statusGeneration) return;
      gate(!result.isLoggedIn ? 'guest' : !result.isMember ? 'join' : result.member?.status === 'active' && !result.member.revoked ? 'active' : 'inactive');
      if (active) roots.forEach(loadPrivate);
    } catch (_) { if (generation === statusGeneration) gate('unavailable'); }
  }
  function safeImage(value) {
    try { const url = new URL(value); return url.protocol === 'https:' ? url.href : null; } catch (_) { return null; }
  }
  async function loadFeed(root) {
    const target = root.querySelector('[data-ic-feed]');
    if (!target) return;
    target.replaceChildren(node('p', text('loading')));
    try {
      const result = await request('instax-club-feed');
      if (!Array.isArray(result.data)) throw new Error(text('unavailable'));
      const entries = result.data.filter(row => safeImage(row.imageUrl)).slice(0, 24);
      if (!entries.length) { target.replaceChildren(node('p', text('feed_empty'))); return; }
      target.replaceChildren();
      entries.forEach(row => {
        const figure = node('figure'); const img = node('img');
        img.src = safeImage(row.imageUrl); img.alt = String(row.caption || text('photo')); img.loading = 'lazy';
        figure.append(img, node('figcaption', [row.caption, row.member].filter(Boolean).join(' · ')));
        target.append(figure);
      });
    } catch (_) {
      target.replaceChildren(node('p', text('unavailable')));
      const retry = node('button', text('retry'), 'ic-bridge-action'); retry.type = 'button';
      retry.addEventListener('click', () => loadFeed(root)); target.append(retry);
    }
  }
  function statusLabel(value) {
    const known = ['pending','approved','rejected','requested','offered','accepted','declined','received','credited','cancelled'];
    return known.includes(value) ? text(value) : text('status');
  }
  async function loadPrivate(root) {
    if (!active) return;
    const generation = (generations.get(root) || 0) + 1; generations.set(root, generation);
    const community = root.dataset.icBridge === 'community';
    const target = root.querySelector(community ? '[data-ic-my-shares]' : '[data-ic-my-trades]');
    target.replaceChildren(node('p', text('loading')));
    try {
      const result = await request(community ? 'instax-club-my-shares' : 'instax-club-my-trade-ins');
      if (!active || generations.get(root) !== generation) return;
      if (result.isMember === false) { gate('join'); return; }
      if (!Array.isArray(result.data)) throw new Error(text('unavailable'));
      if (community) {
        const balance = root.querySelector('[data-ic-balance]');
        balance.textContent = Number.isFinite(result.balance) ? String(result.balance) : '—';
      }
      target.replaceChildren();
      if (!result.data.length) { target.append(node('p', text(community ? 'shares_empty' : 'trades_empty'))); return; }
      result.data.forEach(row => {
        const item = node('article', null, 'ic-bridge-item');
        item.append(node('strong', community ? row.caption || text('photo') : row.deviceModel), node('p', statusLabel(row.status)));
        if (community && Number.isFinite(row.pointsAwarded)) item.append(node('p', row.pointsAwarded + ' ' + text('points')));
        if (row.rejectReason) item.append(node('p', row.rejectReason));
        if (!community) {
          if (row.offerValueUsd != null) item.append(node('p', text('offer') + ': ' + row.offerValueUsd + ' USD'));
          if (row.offerNote) item.append(node('p', row.offerNote));
          if (row.creditTry != null) item.append(node('p', text('credit') + ': ' + row.creditTry + ' TRY'));
          if (row.couponCode) item.append(node('p', text('coupon') + ': ' + row.couponCode + (row.couponUsed ? ' · ' + text('used') : '')));
          const actions = node('div', null, 'ic-bridge-actions');
          if (row.status === 'offered') ['accept','decline'].forEach(action => addAction(root, item, actions, row.id, action));
          if (['requested','offered','accepted'].includes(row.status)) addAction(root, item, actions, row.id, 'cancel');
          item.append(actions);
        }
        target.append(item);
      });
    } catch (_) { if (active && generations.get(root) === generation) target.replaceChildren(node('p', text('unavailable'))); }
  }
  function addAction(root, item, actions, id, action) {
    const button = node('button', text(action), 'ic-bridge-action'); button.type = 'button';
    button.addEventListener('click', async () => {
      if (!active || !window.confirm(text(action) + ' — ' + text('confirm'))) return;
      actions.querySelectorAll('button').forEach(el => { el.disabled = true; });
      try { await request('instax-club-trade-in-respond', { id, action }); await loadPrivate(root); }
      catch (error) { item.append(node('p', error.message)); actions.querySelectorAll('button').forEach(el => { el.disabled = false; }); }
    });
    actions.append(button);
  }
  function readPhoto(file) {
    if (!file || !['image/jpeg','image/png','image/webp'].includes(file.type) || file.size > 3 * 1024 * 1024) return Promise.reject(new Error(text('bad_file')));
    return new Promise((resolve, reject) => {
      const reader = new FileReader(); reader.onerror = () => reject(new Error(text('bad_file')));
      reader.onload = () => resolve({ imageBase64: reader.result, mime: file.type }); reader.readAsDataURL(file);
    });
  }
  async function submit(root, form) {
    if (!active || !form.reportValidity()) return;
    const button = form.querySelector('button[type=submit]');
    if (button.disabled) return;
    const community = !!form.hasAttribute('data-ic-share-form');
    const label = button.textContent; button.disabled = true; button.textContent = text('saving'); message(form, '', false);
    let saved = false;
    try {
      let body;
      if (community) body = { ...await readPhoto(form.elements.photo.files[0]), caption: form.elements.caption.value, consentAccepted: form.elements.consent.checked, allowSocialReuse: form.elements.social.checked };
      else {
        const files = Array.from(form.elements.photos.files);
        if (files.length > 3) throw new Error(text('many_files'));
        body = { deviceModel: form.elements.model.value, deviceBrand: 'Fujifilm', condition: form.elements.condition.value, notes: form.elements.notes.value, photos: await Promise.all(files.map(readPhoto)) };
      }
      const result = await request(community ? 'instax-club-share' : 'instax-club-trade-in', body);
      if (result.ok !== true) throw new Error(result.error || text('error'));
      saved = true; form.reset(); message(form, text(community ? 'share_saved' : 'trade_saved'), false);
      await loadPrivate(root);
    } catch (error) { if (!saved) message(form, error.message || text('error'), true); }
    finally { button.disabled = !active; button.textContent = label; }
  }
  roots.forEach(root => {
    root.dataset.icBridgeStarted = 'true';
    root.querySelector('[data-ic-retry]').addEventListener('click', loadMember);
    root.querySelector('[data-ic-refresh]').addEventListener('click', () => loadPrivate(root));
    const form = root.querySelector('form'); form.addEventListener('submit', event => { event.preventDefault(); submit(root, form); });
    loadFeed(root);
  });
  document.addEventListener('instax:member', event => {
    statusGeneration++; gate(event.detail?.active ? 'active' : 'inactive'); if (active) roots.forEach(loadPrivate);
  });
  loadMember();
})();
